// @flow

import './default-bundle';

import ExternalElementPopup from '@components/popups/ExternalElementPopup';

ReactOnRails.register({
  ExternalElementPopup
});
